'use strict';

var AssertError = require('./error');

var internals = {};

module.exports = function (condition) {
  if (condition) {
    return;
  }

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (args.length === 1 && args[0] instanceof Error) {
    throw args[0];
  }

  throw new AssertError(args);
};